import { useQuery } from "@tanstack/react-query";
import { uniq } from "lodash";
import { useGeotabClient } from "@/components/GeotabClientContext";
import VinDetail from "@/models/VinDetail";

export function useDecodeVins(vins?: string[]) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const uniqueIds = vins ? uniq(vins) : [];

  return useQuery<VinDetail[]>({
    queryKey: ["vins", activeSessionId, uniqueIds],

    queryFn: async ({ signal }) => {
      if (uniqueIds.length === 0) {
        return [];
      }

      const res = ((await geotabClient.call(
        "DecodeVinsNew",
        {
          vins: uniqueIds,
        },
        signal,
      )) ?? []) as VinDetail[];
      return res;
    },
    enabled: !!uniqueIds.length,
  });
}
